module.exports = __webpack_public_path__ + "img/riskIconBass.27378368.png";